import type {
  CLSMetricWithAttribution,
  FCPMetricWithAttribution,
  INPMetricWithAttribution,
  LCPMetricWithAttribution,
  TTFBMetricWithAttribution,
} from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';

export const toClsReport = (metric: CLSMetricWithAttribution): MetricReport => {
  const a = metric.attribution;
  return {
    name: 'cumulative-layout-shift',
    value: metric.value,
    unit: '',
    rating: metric.rating,
    navigationType: metric.navigationType,
    id: metric.id,
    delta: metric.delta,
    attribution: {
      kind: 'cls',
      largestShiftTarget: a?.largestShiftTarget,
      largestShiftTime: a?.largestShiftTime,
      largestShiftValue: a?.largestShiftValue,
      loadState: a?.loadState,
    },
  };
};

export const toInpReport = (metric: INPMetricWithAttribution): MetricReport => {
  const a = metric.attribution;
  return {
    name: 'interaction-to-next-paint',
    value: metric.value,
    unit: 'ms',
    rating: metric.rating,
    navigationType: metric.navigationType,
    id: metric.id,
    delta: metric.delta,
    attribution: {
      kind: 'inp',
      interactionTarget: a?.interactionTarget,
      interactionType: a?.interactionType,
      inputDelay: a?.inputDelay,
      processingDuration: a?.processingDuration,
      presentationDelay: a?.presentationDelay,
      loadState: a?.loadState,
      longestScriptDuration: a?.longestScript?.intersectingDuration,
      totalScriptDuration: a?.totalScriptDuration,
      totalStyleAndLayoutDuration: a?.totalStyleAndLayoutDuration,
    },
  };
};

export const toLcpReport = (metric: LCPMetricWithAttribution): MetricReport => {
  const a = metric.attribution;
  return {
    name: 'largest-contentful-paint',
    value: metric.value,
    unit: 'ms',
    rating: metric.rating,
    navigationType: metric.navigationType,
    id: metric.id,
    delta: metric.delta,
    attribution: {
      kind: 'lcp',
      target: a?.target,
      url: a?.url,
      timeToFirstByte: a?.timeToFirstByte,
      resourceLoadDelay: a?.resourceLoadDelay,
      resourceLoadDuration: a?.resourceLoadDuration,
      elementRenderDelay: a?.elementRenderDelay,
    },
  };
};

export const toFcpReport = (metric: FCPMetricWithAttribution): MetricReport => {
  const a = metric.attribution;
  return {
    name: 'first-contentful-paint',
    value: metric.value,
    unit: 'ms',
    rating: metric.rating,
    navigationType: metric.navigationType,
    id: metric.id,
    delta: metric.delta,
    attribution: {
      kind: 'fcp',
      timeToFirstByte: a?.timeToFirstByte,
      firstByteToFCP: a?.firstByteToFCP,
      loadState: a?.loadState,
    },
  };
};

export const toTtfbReport = (
  metric: TTFBMetricWithAttribution,
): MetricReport => {
  const a = metric.attribution;
  return {
    name: 'time-to-first-byte',
    value: metric.value,
    unit: 'ms',
    rating: metric.rating,
    navigationType: metric.navigationType,
    id: metric.id,
    delta: metric.delta,
    attribution: {
      kind: 'ttfb',
      waitingDuration: a?.waitingDuration,
      cacheDuration: a?.cacheDuration,
      dnsDuration: a?.dnsDuration,
      connectionDuration: a?.connectionDuration,
      requestDuration: a?.requestDuration,
    },
  };
};
